import { gql } from "@apollo/client";

const ORGANIZATION_PLATFORMS = gql`
  query organizationPlatforms($filter: ListOrganizationPlatformsInput!, $relations: [String!]) {
    organizationPlatforms(filter: $filter, relations: $relations) {
      id
      federation {
        id
        organizationName
        organizationAbbreviation
        contactEmail
        status
        contactPhone
        logo
        user {
          email
          id
          name
          phone
          role
          surname
          website
        }
        about
        createdAt
      }
      isTournatedFeeVatEnable
      tournatedFeeVat
      platform {
        id
        title
        currency
        platformType
        status
        country
        language
        sports {
          id
          sport {
            id
            title
            icon
          }
          createdAt
        }
        owner {
          id
          user {
            id
          }
        }
        customFee {
          id
          rangeStart
          rangeEnd
          feeType
          serviceType
          feeMode
          tournatedFee
          tournatedMinFee
          tournatedMaxFee
          partnerFee
          partnerMinFee
          partnerMaxFee
          currency
          isMonetization
          isManagerPayingServiceFee
        }
        isTournatedFeeVatEnable
        tournatedFeeVat
        uploadFile
        coverPhoto
        lightLogo
        darkLogo
      }
    }
  }
`;

export default ORGANIZATION_PLATFORMS;
